import { render, staticRenderFns } from "./MenuRegistration.vue?vue&type=template&id=3a9fbbe9&scoped=true"
import script from "./MenuRegistration.vue?vue&type=script&lang=js"
export * from "./MenuRegistration.vue?vue&type=script&lang=js"
import style0 from "./MenuRegistration.vue?vue&type=style&index=0&id=3a9fbbe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9fbbe9",
  null
  
)

export default component.exports